import { PropertyTypeEnum } from 'api/real-estate';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { QuickGroupSurvey } from 'features/subscription-process/profiling-process/components/Survey/QuickGroupSurvey';
import { selectAnswers, selectVisibleSteps, selectQuestionsAndAnswersMappingWithEligibility } from 'features/subscription-process/profiling-process/slices/genericSelectors';
import { goToFirstStep } from 'features/subscription-process/profiling-process/slices/genericProfilingSlice';
import { IconPossibleAnswer, PossibleAnswer } from 'features/subscription-process/profiling-process/types/interfaces';
import { RealEstateFormValues } from '../../types/realEstateFormValues';
import { RealEstateFormFieldNames } from '../../types/realEstateFormFieldNames';

const PROPERTY_TYPE_QUESTION_KEY = "typeBien";

export const RealEstateSurveyLayout = () => {
  const { t } = useTranslation('realEstate');
  const { setFieldValue } = useFormikContext<RealEstateFormValues>();
  const dispatch = useAppDispatch();
  const visibleSteps = useAppSelector(selectVisibleSteps);
  const existingAnswers = useAppSelector(selectAnswers);
  const { eligibilityMessages } = useAppSelector(selectQuestionsAndAnswersMappingWithEligibility);

  useEffect(() => {
    dispatch(goToFirstStep());
  }, [dispatch]);

  const handleChange = useCallback(
    (answers: Record<string, PossibleAnswer[]>) => {
      const formatted: Record<string, any> = {};
      Object.entries(answers).forEach(([key, values]) => {
        formatted[key] = values && values.length > 0 ? values : null;
      });
      setFieldValue(RealEstateFormFieldNames.SurveyForm, formatted);

      // Sync typeBien (survey) → propertyType (Formik)
      if (PROPERTY_TYPE_QUESTION_KEY in answers) {
        const typeBienAnswers = answers[PROPERTY_TYPE_QUESTION_KEY];
        if (typeBienAnswers && typeBienAnswers.length > 0) {
          const selectedAnswer = typeBienAnswers[0] as IconPossibleAnswer;
          const propertyType = parseInt(selectedAnswer.key as string) as PropertyTypeEnum;
          setFieldValue(RealEstateFormFieldNames.PropertyType, propertyType);
        }
      }
    },
    [setFieldValue]
  );

  return (
    <div className="relative mt-4">
      <QuickGroupSurvey
        groups={visibleSteps}
        existingAnswers={existingAnswers}
        onChange={handleChange}
        title={t('REAL_ESTATE.SECTIONS.ABOUT_PROPERTY')}
        showEligibilityWarnings
        eligibilityMessages={eligibilityMessages}
      />
    </div>
  );
};
